import { getWidgetTemplate } from '../data/widgets';

function lines(value) {
  if (Array.isArray(value)) {
    return value;
  }
  return String(value || '')
    .split('\n')
    .map((item) => item.trim())
    .filter(Boolean);
}

function WidgetRenderer({ widget }) {
  const template = getWidgetTemplate(widget.templateId);
  const settings = widget.settings || {};
  const templateId = widget.templateId;

  if (templateId === 'life-lessons') {
    return (
      <div className="widget-renderer">
        <h3>{settings.title || widget.name}</h3>
        <ol>
          {lines(settings.lessons).map((lesson) => <li key={lesson}>{lesson}</li>)}
        </ol>
      </div>
    );
  }

  if (templateId === 'chapter-map') {
    return (
      <div className="widget-renderer chapter-map">
        {lines(settings.chapters).map((chapter) => (
          <span className={chapter === settings.activeChapter ? 'active-chip' : ''} key={chapter}>{chapter}</span>
        ))}
      </div>
    );
  }

  if (templateId === 'private-compass') {
    return (
      <div className="widget-renderer">
        <h3>{settings.focus || widget.name}</h3>
        <p>{settings.nextStep}</p>
        <p className="muted">{settings.notes}</p>
      </div>
    );
  }

  if (templateId === 'memory-game') {
    return (
      <div className="widget-renderer">
        <h3>{settings.prompt || widget.name}</h3>
        <ul>
          {lines(settings.answers).map((answer) => <li key={answer}>{answer}</li>)}
        </ul>
        <p className="muted">Answer: {settings.correctAnswer}</p>
      </div>
    );
  }

  return (
    <div className="widget-renderer">
      <h3>{widget.name || template?.name || 'Custom widget'}</h3>
      {Object.entries(settings).map(([key, value]) => (
        <p key={key}><strong>{key}:</strong> {String(value)}</p>
      ))}
    </div>
  );
}

export default WidgetRenderer;
